import { assign } from 'xstate';
import { AppBarEvent } from '../../../events';
import { AppBarMachineContext } from '../../../machineContext';

export const name = 'setTargetOpenExpanded';

export const fn = assign<AppBarMachineContext, AppBarEvent>({
  target: () => 'openExpanded',
});

export const action = {
  [name]: fn,
};

export default action;
